export default __webpack_public_path__ + "static/media/SantanderBootcamp.0932f3ad.jpg";